import { useQuery } from 'react-query';

import { axios } from 'lib';

const getLots = (resource, id) => {
  return axios.get(`/api/${resource}/${id}/setup/lots`);
};

export const useLots = (resource, id, options = {}) => {
  return useQuery(`${resource}-${id}-setup-lots`, () => getLots(resource, id), {
    //@ts-ignore
    initialData: { data: { data: [] } },
    select: ({ data }) => data.data,
    ...options,
  });
};
